import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b3f2ba2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "wrapper-input position-relative" }
const _hoisted_3 = ["disabled", "minlength", "type", "placeholder"]
const _hoisted_4 = {
  key: 0,
  class: "pi pi-search pr-2 d-flex position-absolute",
  style: `
          color: #708090;
          right: 0; top: 0;
          bottom: 0;
          display: flex;
          pointer-events: none;
          align-items: center;
        `
}

import { ref, Ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseInput',
  props: {
  label: String,
  placeholder: String,
  modelValue: String,
  inputRequired: {
    type: Boolean,
    default: true,
  },
  showIcon: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  removeMargin: {
    type: Boolean,
    default: false,
  },
  inputType: {
    type: String,
    default: "text",
  },
  minLength: {
    type: Number,
    default: 0,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;



const inputValue: Ref<string> = ref("");



watch(inputValue, (val) => {
  emit("update:modelValue", val);
});

watch(
  () => props.modelValue,
  (val) => {
    inputValue.value = val || "";
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-group", {
      'mb-0': __props.removeMargin,
    }])
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        style: {"height":"49.6px"},
        disabled: __props.disabled,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
        minlength: __props.minLength,
        type: __props.inputType,
        class: "form-control",
        placeholder: __props.placeholder
      }, null, 8, _hoisted_3), [
        [_vModelDynamic, inputValue.value]
      ]),
      (__props.showIcon)
        ? (_openBlock(), _createElementBlock("i", _hoisted_4))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})